import React from "react";
import ExportContent from "../components/export/export-content";

const Export = () => {
  return <ExportContent />;
};

export default Export;
